import React from 'react';
import { ChevronRight } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { fmtDateTime } from './familyApi';

const Row = ({ a, onOpen }) => (
  <button type="button" data-testid={`family-account-row-${a.user_id}`} onClick={() => onOpen(a)}
    className="w-full text-left flex items-center gap-3 rounded-2xl border-2 border-amber-200 bg-white p-3 sm:p-4 hover:border-amber-400 hover:shadow-md transition-[border-color,box-shadow]">
    <div className="h-11 w-11 shrink-0 rounded-full bg-amber-500 text-white flex items-center justify-center font-bold text-lg">
      {(a.name || '?').charAt(0).toUpperCase()}
    </div>
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <span data-testid={`family-account-name-${a.user_id}`} className="font-bold text-slate-800 truncate">{a.name}</span>
        {a.relationship && <span className="text-xs text-slate-500">· {a.relationship}</span>}
      </div>
      <div className="text-xs text-slate-500 truncate">{a.email}</div>
      <div className="text-xs text-slate-400">Last sign-in: {fmtDateTime(a.last_login)}</div>
    </div>
    <div className="flex flex-col items-end gap-1">
      <StatusBadge access={a.access} testId={`family-account-status-${a.user_id}`} />
      <ChevronRight size={18} className="text-amber-600" />
    </div>
  </button>
);

export const AccountList = ({ accounts, onOpen }) => (
  <div data-testid="family-account-list" className="space-y-3">
    <h3 className="text-lg font-bold text-slate-800">Your people ({accounts.length})</h3>
    {accounts.length === 0
      ? <div data-testid="family-account-list-empty" className="rounded-2xl bg-slate-50 p-6 text-center text-slate-500">No accounts yet. Create your first one above.</div>
      : accounts.map((a) => <Row key={a.user_id} a={a} onOpen={onOpen} />)}
  </div>
);
